import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

import api from "./api";

const PUSH_TOKEN_KEY = "tuEnfermeraPushToken";
let initialized = false;

export const isNativeApp = () => Capacitor.isNativePlatform();

export const initializePushNotifications = async () => {
  if (!isNativeApp() || initialized) return;
  initialized = true;

  await PushNotifications.addListener("registration", async ({ value }) => {
    localStorage.setItem(PUSH_TOKEN_KEY, value);
    await api.post("/devices", {
      token: value,
      platform: Capacitor.getPlatform(),
    });
  });

  await PushNotifications.addListener("registrationError", (error) => {
    console.error("No fue posible registrar las notificaciones", error);
  });

  await PushNotifications.addListener(
    "pushNotificationActionPerformed",
    ({ notification }) => {
      const ticketId = notification?.data?.ticketId;
      if (ticketId) {
        window.location.assign(`/tickets/${ticketId}`);
      }
    }
  );

  await PushNotifications.createChannel({
    id: "messages",
    name: "Mensajes de pacientes",
    description: "Avisos de nuevas conversaciones de Tu Enfermera",
    importance: 4,
    visibility: 0,
    vibration: true,
  });

  let permission = await PushNotifications.checkPermissions();
  if (permission.receive === "prompt") {
    permission = await PushNotifications.requestPermissions();
  }

  if (permission.receive === "granted") {
    await PushNotifications.register();
  }
};

export const unregisterCurrentPushDevice = async () => {
  if (!isNativeApp()) return;

  const token = localStorage.getItem(PUSH_TOKEN_KEY);
  if (token) {
    try {
      await api.delete("/devices", { data: { token } });
    } finally {
      localStorage.removeItem(PUSH_TOKEN_KEY);
    }
  }

  await PushNotifications.unregister();
  await PushNotifications.removeAllListeners();
  initialized = false;
};
